<app-resp-popup-title
  i18n="@@Planung_TaskContactCreate_Title:Add a new contact"
  >
  Add a new contact
</app-resp-popup-title>
<app-resp-popup-content
  ><div class="wrapper">
  @if (form) {
    <form [formGroup]="form" class="cst-form">
      <div class="row">
        <div class="col-auto">
          <app-planung-taskcard-avatar
            size="big"
            [contact]="form.value"
          ></app-planung-taskcard-avatar>
        </div>
        <div class="col">
          <div class="row">
            <div class="col">
              <frm-text
                i18n-label="@@Planung_TaskContactCreate_Email"
                label="E-Mail"
                formControlName="email"
                type="email"
                />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <frm-text
                  i18n-label="@@Planung_TaskContactCreate_Label"
                  i18n-hint="@@Planung_TaskContactCreate_Label_Hint"
                  label="Label"
                  hint="E.g.: Firstname and lastname"
                  [optional]="true"
                  formControlName="label"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </app-resp-popup-content>
  <app-resp-popup-actions>
    <ctrl-btn-accept (click)="OnAccept()" [disabled]="!form.valid" />
    <ctrl-btn-cancel (click)="OnCancel()" />
  </app-resp-popup-actions>
